<template>
  <button @click.stop.prevent="open">
    <slot></slot>
  </button>
</template>

<script setup>
import { useFileDialog } from '@vueuse/core'

const props = defineProps({
  attachmentType: Object
})

const emit = defineEmits('onFileSelect')

const { open, onChange } = useFileDialog({
  accept: props.attachmentType?.allowedMimeType || '.pdf, .jpeg, .jpg'
})

onChange((files) => {
  emit('onFileSelect', files[0])
})
</script>

<style lang="scss" scoped></style>
